// student-frontend/src/pages/Games/Home/game-card.tsx
import { useState } from "react";
import { ActivityGame } from "../../../modules/games/game";
import { GameLauncher } from "../../../modules/games/launcher/game-launcher";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import styles from "./game-card.module.css";

type GameCardProps = {
    game: ActivityGame;
    canPlay: boolean; // true if centre has Games add-on OR providerId === 'mygooroo'
};

export const GameCard = (props: GameCardProps) => {
  const { game, canPlay } = props;
  const navigate = useNavigate();
  const [showLocked, setShowLocked] = useState(false);

  const onCardClick = () => {
      if (canPlay) {
    GameLauncher.launch(game, navigate);
        } else {
            setShowLocked(true);
        }
  }

  return (
      <>
    <div style={{ width: "250px", height: "300px" }}>
      <div className={"position-relative px-3 pt-3 h-100 w-100 rounded-3 cursor-pointer " + styles.gamecard} style={{border: "1px solid black",boxShadow: "5px 5px 5px 0px #ADC0CE"
          , opacity: canPlay ? 1 : 0.55}} onClick={onCardClick} aria-disabled={!canPlay}>
                    {/* Lock ribbon/overlay */}
                    {!canPlay && (
                        <div
                            className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                            style={{
                                background: "linear-gradient(0deg, rgba(0,0,0,0.40), rgba(0,0,0,0.40))",
                                borderRadius: "0.3rem",
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "#dc3545",
                                    color: "#fff",
                                    padding: "6px 10px",
                                    borderRadius: 4,
                                    fontWeight: 700,
                                    fontSize: "0.9rem",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                Requires Games add-on
                            </div>
                        </div>
                    )}

        <div className="d-flex justify-content-center">
          <div style={{ width: "140px", height: "140px", flex: "none" }}>
            <img src={game.image} alt={game.name} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="w-100 mt-2">
          <div style={{ fontWeight: "bold" }}>{game.name}</div>
          {/*TODO: country is not available in student app yet. implement country. using UK for now*/}
          <div><span style={{ fontWeight: "bold" }}>Year Level: </span>{game.getYearLevels(183)}</div>
          <div><span style={{ fontWeight: "bold" }}>Topic: </span>{game.description}</div>
          <br />
        </div>
      </div>
    </div>
    {/* Locked-modal */}
    <Modal isOpen={showLocked} toggle={() => setShowLocked(false)} centered>
        <ModalHeader toggle={() => setShowLocked(false)}>
            Game locked
        </ModalHeader>
        <ModalBody>
            <div className="mb-2">
                This game requires the <strong>Centre Games add-on</strong>. Your centre is not currently
                subscribed, so this title can’t be played.
            </div>
            <div>
                You can still play games from <strong>MyGooRoo</strong>. Look for cards without the red
                “Requires Games add-on” label.
            </div>
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={() => setShowLocked(false)}>
                 OK
            </Button>
        </ModalFooter>
    </Modal>

        </>
  )
}